<template>
    <app-layout title="Přijaté zprávy" @refreshMessages="refreshMessages">

        <MessagesTable v-if="messages.length > 0" type="inbox" :messages="messages" @refreshMessages="refreshMessages"/>

        <MessagesTableNoMessages v-else/>

        <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { useToast } from "vue-toastification";
import MessagesTable from "../Components/MessagesTable";
import MessagesTableNoMessages from "../Components/MessagesTableNoMessages";

export default {
    components: {
        MessagesTableNoMessages,
        MessagesTable,
        AppLayout,
    },
    data() {
        return {
            messages: this.$page.props.messages,
            lastUpdate: this.$page.props.lastUpdate,
            page: this.$page.props.page,
            maxPage: this.$page.props.maxPage,
            search: this.$page.props.search,

            activePage: this.$page.props.activePage,
            settings: this.$page.props.settings,

            refreshMessagesInterval: null,

            showMessageOptions: null,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    updated(){

    },
    mounted(){
        this.setUpEcho();

    },
    unmounted(){
        this.destroyEcho();
    },

    methods: {
        setUpEcho(){
            console.log('stup up echo inbox')
            Echo.private('App.Models.User.' + this.$page.props.user.id)
                .listen('MessagesChanged', (e) => {
                    console.log('MessagesChanged', e);
                    this.refreshMessages();
                })
        },
        destroyEcho(){
            console.log('destroy up echo inbox')
            Echo.leave('App.Models.User.'+this.$page.props.user.id);
        },
        refreshMessages(manual = 0){
            let data = {direction: 1, page: this.page, search: this.search, manual: manual, longterm: this.activePage === 'longterminbox' ? 1 : 0}
            axios.get(route('fapi.messages', data))
                .then(response => {
                    if(response.status === 200){
                        this.messages = response.data.messages;
                        this.page = response.data.page;
                        this.maxPage = response.data.maxPage;
                        this.lastUpdate = response.data.lastUpdate;
                    }
                })
                .catch(error => {
                    if(manual) this.toast.warning('Něco se pokazilo. Zkuste to později.');
                });
        },

    }
}

</script>

